module.exports = __webpack_public_path__ + "static/1-cb04e7893981e5626cf05e0cfedbee25.jpg";